import React from "react";

import HTML5 from "../images/services/HTML5.png";
import ReactJs from "../images/services/React.png";
import Wordpress from "../images/services/Wordpress.png";


const Services = () =>{
    const services=[
        {
            title:"Html Development",
            icon:HTML5,
            description:"Convert designs (PSD) into code (HTML,CSS,JS)"
        },
        {
            title:"React App Development",
            icon:ReactJs,
            description:"PSD to React, edit React App"
        },
        {
            title:"Wordpress Development",
            icon:Wordpress,
            description:"Create/Edit wordpress website , Improve wordpress website UI/UX"
        }
    ]
    return (
        <div className="services-section" id="service_section">
            <div className="section-padding text-center">
            <h4 className="section-title">Services</h4>
                <div className="services-holder">
                    {services.map(item => <div key={item.title} className="service-item">
                        <img src={item.icon} alt={item.title} className="service-icon" />
                        <h3 className="simple-title">{item.title}</h3>
                        <p className="">{item.description}</p>
                    </div>)}
                </div>
            </div>
        </div>
    )
}

export default Services;